// extracted by mini-css-extract-plugin
export var askAiIcon = "_oc-j";
export var category = "_oc-9";
export var categoryHeader = "_oc-e";
export var container = "_oc-0";
export var group = "_oc-a";
export var groupItems = "_oc-f";
export var groupSeparator = "_oc-k";
export var loading = "_oc-1";
export var noResults = "_oc-3";
export var placeholder = "_oc-2";
export var resultContent = "_oc-5";
export var resultIcon = "_oc-c";
export var resultItem = "_oc-g";
export var resultMeta = "_oc-8";
export var resultSubtitle = "_oc-7";
export var resultSuffix = "_oc-i";
export var resultTitle = "_oc-6";
export var resultsList = "_oc-4";
export var searchGroup = "_oc-d";
export var selected = "_oc-h";
export var subgroup = "_oc-b";